import { ComponentProps, FC } from "react";

import { useTranslate } from "@/hooks/useTranslate";
import { ChildrenOrI18nType } from "@/utils/react";
import { cn } from "@/utils/tailwind";

import { alertVariants, AlertVariantType } from "./variants";

type RmAlertPropsType = ComponentProps<"div"> & AlertVariantType;

export const RmAlert: FC<RmAlertPropsType> = ({
  className,
  variant,
  ...props
}) => {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
};

type RmAlertTitlePropsType = ComponentProps<"div"> & ChildrenOrI18nType;

export const RmAlertTitle: FC<RmAlertTitlePropsType> = ({
  className,
  children,
  i18nKey,
  i18nOptions,
  ...props
}) => {
  const i18nText = useTranslate(i18nKey, i18nOptions);

  return (
    <div
      data-slot="alert-title"
      className={cn(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        className,
      )}
      {...props}>
      {children ?? i18nText}
    </div>
  );
};

type RmAlertDescriptionPropsType = ComponentProps<"div"> & ChildrenOrI18nType;

export const RmAlertDescription: FC<RmAlertDescriptionPropsType> = ({
  className,
  children,
  i18nKey,
  i18nOptions,
  ...props
}) => {
  const i18nText = useTranslate(i18nKey, i18nOptions);

  return (
    <div
      data-slot="alert-description"
      className={cn(
        "col-start-2 grid justify-items-start gap-1 text-sm text-muted-foreground [&_p]:leading-relaxed",
        className,
      )}
      {...props}>
      {children ?? i18nText}
    </div>
  );
};
